// Passo 27 (08/10/2026) — a foto do perfil em tamanho pequeno.
//
// A API manda `foto_url` (o original, até 6,5 MB) e `foto_miniatura_url` (256 px,
// WebP; o próprio servidor já põe o original ali quando falta a miniatura). Toda
// tela mostra a foto a no máximo 80 px: é a miniatura que deve ser pedida. O
// `?? foto_url` é cinto para um navegador com este código falando com um
// servidor ainda sem o campo.
export interface ComFotos {
  foto_url?: string | null;
  foto_miniatura_url?: string | null;
}

export function urlDaFotoPequena(u: ComFotos | null | undefined): string | null {
  return u?.foto_miniatura_url ?? u?.foto_url ?? null;
}
